import { useState } from 'react'
import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { Skeleton } from '@/components/ui/skeleton'
import { useGenerateImage } from '@/lib/api/mutations/draft'

interface ImageGenerateTabProps {
  agentId: string
  draftId: string
  onGenerated: (imageUrl: string) => void
}

export function ImageGenerateTab({ agentId, draftId, onGenerated }: ImageGenerateTabProps) {
  const [prompt, setPrompt] = useState('')
  const generateMutation = useGenerateImage(agentId, draftId)

  const handleGenerate = () => {
    if (!prompt.trim()) return
    generateMutation.mutate({ prompt: prompt.trim() })
  }

  const generatedUrl = generateMutation.data?.imageUrl

  return (
    <div className="space-y-4 py-4">
      <Textarea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder="Describe the image you want..."
        rows={3}
      />

      <Button
        onClick={handleGenerate}
        disabled={!prompt.trim() || generateMutation.isPending}
        className="w-full"
      >
        {generateMutation.isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        Generate Image
      </Button>

      {generateMutation.isPending && (
        <Skeleton className="aspect-video w-full rounded-lg" />
      )}

      {generatedUrl && !generateMutation.isPending && (
        <div className="space-y-3">
          <div className="aspect-video rounded-lg overflow-hidden">
            <img
              src={generatedUrl}
              alt="Generated preview"
              className="w-full h-full object-cover"
            />
          </div>
          <Button onClick={() => onGenerated(generatedUrl)} className="w-full">
            Use This Image
          </Button>
        </div>
      )}
    </div>
  )
}
